import {
  Box,
  BoxProps,
  Button,
  IconButton,
  useTheme
} from '@mui/material';
import { DateTime } from 'luxon';
import {
  ChatMessagePane,
  ChatPaneHeader,
  CustomIcons
} from 'modules';
import { useState } from 'react';
import * as ds from './dataService';


export type ChatPaneProps = {
  listedCompanyId?: string;
  defaultOpen?: boolean;
};

type SelectedPane = 'ASK' | 'HISTORY';

export const FC = (props: ChatPaneProps & BoxProps) => {
  const theme = useTheme();
  const [
    expanded,
    setExpanded
  ] = useState<boolean>(props.defaultOpen ?? false);
  const [
    selectedPane,
    setSelectedPane
  ] = useState<SelectedPane>('ASK');
  const [
    fnSendMessage,
    sendMessageTuple
  ] = ds.useSendMessage();
  const [
    fnSendContextMessage,
    sendContextMessageTuple
  ] = ds.useSendContextMessage();
  const [
    fnSendMessageRequestingGlAccountData,
    fnSendMessageRequestingGlAccountDataTuple
  ] = ds.useSendMessageRequestingGlAccountData(props.listedCompanyId ?? '');
  const { data } = ds.useQuery(props.listedCompanyId ?? '');



  const handleSubmit = async (value: string) => {
    const results = await fnSendMessage({
      listedCompanyId: props.listedCompanyId ?? '',
      message: value
    });
    return results;
  };

  const isAwaitingMessageResponse = sendMessageTuple.loading || sendContextMessageTuple.loading;

  if (expanded) {
    return (
      <Box
        height='inherit'
        sx={{
          overflow: 'hidden'
        }}
        display='flex'
        minWidth='20vw'
        flexDirection='column'
        borderRadius='1rem'
        flex={props.flex ? props.flex : '1 1 0'}
        bgcolor={theme.palette.primary.main}
      >
        {/* CHAT HEADER BAR */}
        <ChatPaneHeader.FC
          ticker={data.ticker}
          companyName={data.companyName}
        >
          {!props.defaultOpen ? (
            <IconButton
              onClick={() => setExpanded((prev) => !prev)}
              sx={{
                backgroundColor: theme.palette.primary.darker200,
                borderRadius: '.5rem'
              }}
            >
              <CustomIcons.MediumIcon.FC icon='COLLAPSE' stroke='white' />
            </IconButton>
          ) : <Box />}
          <Box
            display='flex'
            flexWrap='wrap'
            bgcolor={theme.palette.primary.darker200}
            padding='.125rem'
            borderRadius='.5rem'
          >
            <Button
              variant='contained'
              startIcon={
                <CustomIcons.SmallCustomIcon.FC icon='COMMENT' />
              }
              sx={{
                flex: '1 1 0',
                textWrap: 'nowrap',
                boxShadow: 'none',
                paddingX: '1.5rem',
                borderRadius: '.375rem',
                backgroundColor: selectedPane === 'ASK' ? theme.palette.primary.main : theme.palette.primary.darker200,
                color: selectedPane === 'ASK' ? theme.palette.primary.darker200 : 'white'
              }}
              onClick={() => setSelectedPane('ASK')}
            >
              Ask Sherlock
            </Button>

            <Button
              variant='contained'
              startIcon={<CustomIcons.SmallCustomIcon.FC icon='COMMENT' />}
              sx={{
                flex: '1 1 0',
                boxShadow: 'none',
                paddingX: '1.5rem',
                borderRadius: '.375rem',
                backgroundColor: selectedPane === 'HISTORY' ? theme.palette.primary.main : theme.palette.primary.darker200,
                color: selectedPane === 'HISTORY' ? theme.palette.primary.darker200 : 'white'
              }}
              onClick={() => setSelectedPane('HISTORY')}
            >
              History
            </Button>
          </Box>
        </ChatPaneHeader.FC>

        <ChatMessagePane.FC
          ticker={data.ticker}
          listedCompanyId={props.listedCompanyId}
          showLoadingState={isAwaitingMessageResponse}
          messages={selectedPane === 'HISTORY' ? data.historicalMessages : data.activeMessages}
          selectedPane={selectedPane}
          onSelectContextQuestion={(contextQuestionId) => {
            if (props.listedCompanyId) {
              fnSendContextMessage(contextQuestionId, props.listedCompanyId);
            }
          }}
          onSelectGlAccount={(glAccountId) => {
            if (props.listedCompanyId) {
              const now = DateTime.now();

              fnSendMessageRequestingGlAccountData({
                variables: {
                  input: {
                    glAccountId,
                    start: now
                      .minus({
                        years: 6
                      })
                      .startOf('year'),
                    end: now
                      .minus({
                        years: 1
                      })
                      .startOf('year'),
                    frequency: 'quarterly'
                  }
                }
              });
            }
          }}
        />

        {/* INPUT COMPONENT */}
        {/* {selectedPane === 'ASK' && (
          <ChatInputField.FC
            disabled={isAwaitingMessageResponse}
            listedCompanyId={props.listedCompanyId ?? ''}
            handleSubmit={handleSubmit}
          />
        )} */}
      </Box>
    );

  } else {
    return (
      <Box
        display='flex'
        height='inherit'
        flexDirection='column'
        padding='1rem 0rem 0.75rem 0rem'
        borderRadius='1rem'
        width='4rem'
        minHeight='10rem'
        alignItems='center'
        bgcolor={theme.palette.primary.main}
      >
        <IconButton
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            width: '2rem',
            backgroundColor: theme.palette.primary.darker200,
            borderRadius: '.5rem'
          }}
        >
          <CustomIcons.MediumIcon.FC icon='COLLAPSE' stroke='white' />
        </IconButton>
      </Box>
    );
  }
};
